import { Div, Link, Span } from "@tblabs/truffle";
import { ContactInfo } from "./ContactInfo";
import { Heading } from "../../Components/Heading";
import { Icons } from "../../Components/Utils/Icons";
import { Svg } from "../Components/Utils/Svg";
import { Markdown } from "../../Components/Utils/Markdown";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { Page } from "../Product/Page";
import { PageFooter } from "../Main/PageFooter";


export class ContactPage extends Page
{
    constructor(_shop: ShopContentProvider)
    {
        super("specTeam.pl - Kontakt");

        this.Append(new PageFooter(_shop));

        this.Content(async (body) =>
        {
            body.PaddingLeft(8).PaddingRight(8).Append(
                new Div("contact").Append(

                    new Div("contact__header").Append(
                        new Heading("Skontaktuj się z nami", 1, "contact__title"),
                        new Span("Jesteśmy tutaj, aby Ci pomóc").Italic(),
                    ),

                    new Div("contact__section").Append(
                        new Div("contact-info").Append(
                            new ContactInfo(Icons.Phone, "Telefon", "+48 507 293 714"),
                            new ContactInfo(Icons.Mail, "E-mail", "specteam@specteam.pl"),
                            // new ContactInfo(Icons.Home, "Adres", "Warszawa"),
                        ),
                    ),

                    new Div("contact__section").Append(
                        new Heading("Odbiór osobisty", 2, "contact__section-title"),
                        new Markdown(`- Pragniemy zaznaczyć iż **miejsce odbioru** jest **zależne od dostępności** danego przedmiotu w wybranym terminie!\n- Po zamówienie można się zgłosić **dopiero po** jego **potwierdzeniu** w systemie zamówień,
                    \n- Pojawienie się na miejscu bez uprzednio potwierdzonego zamówienia skutkować będzie najpewniej *pocałowaniem klamki ;)*
                    \n- Przed przyjściem na spotkanie należy zawsze wcześniej **umówić się telefonicznie**`).MarginBottom(16).DisplayBlock(),
                        new Div("contact-info").MarginTop(32).Append(
                            new ContactInfo(Icons.Pin, "Warszawa Wola", "ul. Człuchowska"),
                            new ContactInfo(Icons.Pin, "Warszawa Służew", "ul. Mozarta"),
                            new ContactInfo(Icons.Pin, "Warszawa Bemowo", "ul. Synów Pułku"),
                        ),
                    ),

                    new Div("contact__section").Append(
                        new Heading("Godziny pracy", 2, "contact__section-title"),
                        new Div("hours").Append(
                            new Div("hours__item").Append(
                                new Span("Poniedziałek - Piątek"),
                                new Span("10:00 - 18:00")),
                            new Div("hours__item").Append(
                                new Span("Sobota"),
                                new Span("11:00 - 16:00")),
                            new Div("hours__item hours__item--closed").Append(
                                new Span("Niedziele i święta"),
                                new Span("W miarę potrzeb")),
                        ),
                    ),

                    new Div("contact__section").Append(
                        new Heading("Komunikatory", 2, "contact__section-title"),
                        new Div("messengers").Append(
                            new ContactInfo(Icons.Telegram, "Telegram", "507293714"),
                            new ContactInfo(Icons.Messenger, "Messenger", "facebook.com/specteamwypozyczalnia#"),
                        ),
                    ),

                    new Div("contact__section").Append(
                        new Heading("Nasze social media", 2, "contact__section-title"),
                        new Div("hours").Append(
                            new Div("hours__item").Append(
                                new Div().Append(
                                    new Svg(Icons.Facebook).Style('transform: translateY(6px);'),
                                    new Span("Facebook").MarginLeft(10)
                                ),
                                new Link("https://facebook.com/specteamwypozyczalnia#").OpenInNewCard().Color("#aaa"),
                            ),
                            new Div("hours__item").Append(
                                new Div().Append(
                                    new Svg(Icons.Instagram).Style('transform: translateY(6px);'),
                                    new Span("Instagram").MarginLeft(10)
                                ),
                                new Link("https://www.instagram.com/specteam.pl/").OpenInNewCard().Color("#aaa"),
                            ),
                            new Div("hours__item").Append(
                                new Div().Append(
                                    new Svg(Icons.Youtube).Style('transform: translateY(6px);'),
                                    new Span("Youtube").MarginLeft(10)
                                ),
                                new Link("https://www.youtube.com/@specteam-pl").OpenInNewCard().Color("#aaa"),
                            ),
                        ),
                    ),

                    new Div("contact__section").Append(
                        new Heading("Zwroty", 2, "contact__section-title"),
                        new Div("hours").Append(
                            new Div("hours__item").Append(
                                new Span("Inpost"),
                                new Span(`Paczkomat WAW02H
Człuchowska 2A
01-100 Warszawa
specTeam
507-293-714
specteam@specteam.pl`)),
                            new Div("hours__item").Append(
                                new Span("Osobiste"),
                                new Span(`Warszawa
Wola, Bemowo lub Służew - zależnie od dostępności`)),

                        ),
                    ),

                    // new PageFooter(_shop),
                ),
            )
        });
    }
}
